/**
 * Join Market screen
 */

import { useState } from "preact/hooks";
import { route } from "preact-router";
import { useStore } from "../store";
import { api } from "../api/client";

interface JoinMarketProps {
  inviteCode?: string;
}

export function JoinMarket({ inviteCode: initialCode }: JoinMarketProps) {
  const { deviceId, setMarket, setUser, setSession } = useStore();
  const [inviteCode, setInviteCode] = useState(initialCode ?? "");
  const [displayName, setDisplayName] = useState("");
  const [avatar, setAvatar] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const avatars = ["🎲", "🎰", "🃏", "🎯", "🎪", "🎭", "🎨", "🎸"];

  const handleSubmit = async (e: Event) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const result = await api.joinMarket(inviteCode, {
        displayName,
        avatar: avatar || "🎲",
        deviceId,
      });

      setMarket(result.market);
      setUser(result.user);
      setSession(result.market.id, result.user.id);

      if (result.market.status === "draft") {
        route(`/lobby/${result.market.id}`);
      } else {
        route(`/market/${result.market.id}`);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to join market");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div class="screen join-market">
      <header>
        <button class="btn-back" onClick={() => route("/")}>
          &larr; Back
        </button>
        <h2>Join Market</h2>
      </header>

      <form onSubmit={handleSubmit}>
        <div class="form-group">
          <label for="inviteCode">Invite Code</label>
          <input
            id="inviteCode"
            type="text"
            value={inviteCode}
            onInput={(e) => setInviteCode(e.currentTarget.value.toUpperCase())}
            placeholder="e.g., ABC123"
            maxLength={6}
            required
          />
          <span class="form-hint">
            Get this from whoever created the market.
          </span>
        </div>

        <div class="form-group">
          <label for="displayName">Your Display Name</label>
          <input
            id="displayName"
            type="text"
            value={displayName}
            onInput={(e) => setDisplayName(e.currentTarget.value)}
            placeholder="e.g., Mom"
            required
          />
          <span class="form-hint">How other players will see you.</span>
        </div>

        <div class="form-group">
          <label>Choose Your Avatar</label>
          <div class="avatar-picker">
            {avatars.map((a) => (
              <button
                key={a}
                type="button"
                class={`avatar-option ${avatar === a ? "selected" : ""}`}
                onClick={() => setAvatar(a)}
              >
                {a}
              </button>
            ))}
          </div>
        </div>

        {error && <div class="error">{error}</div>}

        <button type="submit" class="btn btn-primary" disabled={loading}>
          {loading ? "Joining..." : "Join Market"}
        </button>
      </form>
    </div>
  );
}
